import React, { useState, useMemo } from 'react';
import {
  ReceiptLong   as ReceiptLongIcon,
  Folder        as RecordsIcon,
  ContactMail   as InformationIcon,
  Hotel         as BedIcon,
  Healing       as ObservationIcon,
  LocalHospital as DepartmentIcon,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';

import Home              from './Home';
import RecordsList       from './Records/RecordsList';
import PatientInformation from './Records/PatientInformation';
import WardsHome         from './Wards/Home';
import InPatient         from './Wards/InPatient';

// ER menu — combines Records (registration + search) + Wards (bed mgmt +
// observation) into a single workflow. Each Records/Wards file is a literal
// copy under Emergency/, so ER can diverge from the source departments later.
//
// `selectedPatient` is shared between the Records list and the
// PatientInformation tab so "Add New" and "Edit" jump cleanly between them.
export default function Emergency() {
  const [selectedPatient, setSelectedPatient] = useState(null);

  const menuItems = useMemo(() => [
    {
      key:    'Home',
      label:  'Home',
      icon:   <ReceiptLongIcon />,
      render: ({ navigate }) => <Home navigate={navigate} />,
    },
    {
      key:    'Records',
      label:  'Records',
      icon:   <RecordsIcon />,
      render: ({ navigate }) => (
        <RecordsList
          onAddNewPatient={() => {
            setSelectedPatient(null);
            navigate('PatientInformation');
          }}
          onEditPatient={(p) => {
            setSelectedPatient(p);
            navigate('PatientInformation');
          }}
        />
      ),
    },
    {
      key:    'PatientInformation',
      label:  'Patient Information',
      icon:   <InformationIcon />,
      render: ({ navigate }) => (
        <PatientInformation
          selectedPatient={selectedPatient}
          onPatientSaved={() => {
            setSelectedPatient(null);
            navigate('Records');
          }}
        />
      ),
    },
    { key: 'BedManagement', label: 'Bed Management',         icon: <BedIcon />,         component: WardsHome },
    { key: 'InPatient',     label: 'InPatient / Observation',icon: <ObservationIcon />, component: InPatient },
  ], [selectedPatient]);

  return (
    <DepartmentLayout
      departmentId={2}
      departmentName="Emergency (ER/A&E)"
      departmentIcon={<DepartmentIcon />}
      menuItems={menuItems}
    />
  );
}
